<template>
    <div id="app">
        <router-view v-if="isRouterAlive"/>
    </div>
</template>

<script>
  export default {
    name: 'App',
    provide () {
      return {
        reload: this.reload
      }
    },
    data () {
      return {
        isRouterAlive: true
      }
    },
    methods: {
      reload () {
        this.isRouterAlive = false
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      }
    },
    created () {
      // if (sessionStorage.getItem('store')) {
      //   this.$store.replaceState(Object.assign(), this.$store, JSON.parse(sessionStorage.getItem('store')))
      // }
      // window.addEventListener('beforeunload', () => {
      //   sessionStorage.setItem('store', JSON.stringify(this.$store.state.ordinarySearchData))
      // })
    }
  }
</script>

<style>
    #app {
        background: #f2f6f6;
    }

    #app .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #00cccc;
        color: #FFF;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue